import React from "react";
import "./services.scss"
import { ScrollToTopOnMount } from "../../../Components/ScrollToTop/ScrollToTop";
import { Grid } from "@mui/material";
import ServicesGrid from "../../../Components/servicesGrid/servicesGrid";



const ServicesPage = () => {
  ScrollToTopOnMount();

  return (
    <div className="page-main-wrapper service-main-wrapper service-revamp-wrapper f-wrp">
      <div className="service-banner-wrp f-wrp">
        <div className="container">
          <Grid container spacing={1.5}>
            <Grid item xs={12} sm={12} md={6} lg={4}>
              <div className="banner-content-box f-wrp">
                <h1 className="main-title">Services</h1>
                <p>From first-time purchases to growing your portfolio, Propshop Real Estate simplifies every step of your Dubai real estate journey. Get expert help with buying, selling, renting, mortgages, and property evaluations — all in one place.</p>
              </div>
            </Grid>
          </Grid>
        </div>
      </div>

      <div className="service-cont-wrp f-wrp">
        <div className="container">
          <div className='section-header f-wrp'>
            <h1 className="main-title">What We Offer</h1>
          </div>
          <ServicesGrid />
        </div>
      </div>
    </div>
  );
};

export default ServicesPage;
